import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { getShareDirectLinkSelector } from 'common/selectors/index';
import { getSharePathSelector } from '../selectors';
import { SimpleDropDownElement } from 'components/simple-dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/pro-regular-svg-icons';
import { copyToClipboard } from 'utils/copyToClipboard';
import { reduxNotificationAction } from 'components/redux-notification/actions';
import { REDUX_NOTIFICATION_TYPES } from 'components/redux-notification';

export const DirectLinkButton = () => {
  const { t } = useTranslation();
  const isShareDirectLinkEnabled = useSelector(getShareDirectLinkSelector);
  const params = useParams();
  const path = useSelector(getSharePathSelector(params));
  const dispatch = useDispatch();
  const onClick = async () => {
    await copyToClipboard(path);

    dispatch(reduxNotificationAction(i18next.t('direct_link_copied'), true, 5, REDUX_NOTIFICATION_TYPES.SUCCESS));
  };

  return isShareDirectLinkEnabled ? (
    <div data-e2e="direct-link-button">
      <SimpleDropDownElement onClick={onClick}>
        <FontAwesomeIcon icon={faCopy} />
        {t('direct_link')}
      </SimpleDropDownElement>
    </div>
  ) : null;
};
